export class ValueDto <T> {
  public value: T;
}
